import { TabsValue } from '../constants/tabs';

/**
 * Keyed on an explicit `false`: `undefined` means PostHog has not answered, and
 * must not eject a user mid-session. See
 * docs/adr/0003-cross-campaign-conversations-list.md.
 */
export const resolveCampaignsTab = ({
  selectedTab,
  isConversationsTabEnabled,
  hasConversationLink = false
}: {
  selectedTab?: TabsValue;
  isConversationsTabEnabled?: boolean;
  // A `?conversationId=` link: only the Conversations tab can open its drawer.
  hasConversationLink?: boolean;
}): TabsValue => {
  const requestedTab =
    selectedTab ??
    (hasConversationLink && isConversationsTabEnabled
      ? TabsValue.CONVERSATIONS
      : TabsValue.RECRUITMENT);

  const isConversationsTabDisabled = isConversationsTabEnabled === false;

  return requestedTab === TabsValue.CONVERSATIONS && isConversationsTabDisabled
    ? TabsValue.RECRUITMENT
    : requestedTab;
};
